import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import EngineerLayout from './EngineerLayout';
import { 
    FaArrowLeft, 
    FaSearch,
    FaSort
} from 'react-icons/fa';

const EngineerLotterySubWorksDistributionList = () => {
    const navigate = useNavigate();
    const [year, setYear] = useState('वर्ष निवडा');
    const [searchTerm, setSearchTerm] = useState('');

    // Sample data from the image
    const [data] = useState([
        { id: "१", name: "श्री.अक्षय शांताराम इंदोरे", phone: "७७०९६९६०५९", taluka: "आंबेगाव", count: "३", amount: "२२०००००", licenseDate: "२६ जानेवारी २०२७", joinDate: "२०२२" },
        { id: "२", name: "वेदांत सुभाष सावंत", phone: "७७६८०६८३९०", taluka: "आंबेगाव", count: "२", amount: "२०००००००", licenseDate: "२८ ऑक्टोबर २०२६", joinDate: "२०२२" },
        { id: "३", name: "अक्षय सुनील पिसे", phone: "९५११९५११३३", taluka: "बारामती", count: "१", amount: "५०७२१७", licenseDate: "१३ मार्च २०२७", joinDate: "२०२२" },
        { id: "४", name: "अजिंक्य बाळासाहेब लोणकर", phone: "९४०४९९८५९२", taluka: "बारामती", count: "२", amount: "२००००००", licenseDate: "११ जुलै २०२६", joinDate: "२०२२" },
        { id: "५", name: "महावीर बाबुराव बाभळे", phone: "९९७००९९८०९", taluka: "मावळ", count: "५", amount: "४२१३३५७", licenseDate: "२६ ऑगस्ट २०२५", joinDate: "२०२२" },
        { id: "६", name: "श्री.विक्रम देसू राठोड", phone: "९३७००३५८५६", taluka: "मावळ", count: "५", amount: "३७५००००", licenseDate: "११ ऑक्टोबर २०३३", joinDate: "२०२३" },
        { id: "७", name: "किशोर शांताराम दुधाणे", phone: "७२९१८१४१३८", taluka: "भोर", count: "२", amount: "३२१३११", licenseDate: "०२ सप्टेंबर २०२६", joinDate: "२०२२" },
        { id: "८", name: "शुभम चंद्रकांत धुमाळ", phone: "९८५०३१४०५८", taluka: "भोर", count: "३", amount: "१११७७४९", licenseDate: "०२ सप्टेंबर २०२६", joinDate: "२०२२" },
    ]);

    return (
        <EngineerLayout>
            <div className="p-8 bg-[#f4f7fe] min-h-screen font-hind text-left">
                {/* Header Section */}
                <div className="flex justify-between items-center mb-10 px-2 text-left">
                    <div className="flex items-center gap-6">
                        <button 
                            onClick={() => navigate('/engineer/lottery-work-distribution-menu')}
                            className="p-4 bg-white rounded-2xl shadow-sm hover:bg-gray-50 transition-all text-gray-600 border border-gray-100 hover:scale-105 active:scale-95 group"
                        >
                            <FaArrowLeft size={18} className="group-hover:-translate-x-1 transition-transform" />
                        </button>
                        <h1 className="text-2xl font-black text-gray-800 tracking-tight">सुबे  वर्क्स वितरण यादी</h1>
                    </div>
                    <div className="hidden md:flex items-center gap-3 text-[11px] font-black text-gray-400 bg-white px-6 py-3 rounded-2xl border border-gray-100 shadow-sm uppercase tracking-wider">
                        जिल्हा परिषद / <span className="text-purple-600">सुबे  वर्क्स वितरण यादी</span>
                    </div>
                </div>

                {/* Main Content Card */}
                <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
                    {/* Filters Section */}
                    <div className="flex flex-wrap gap-8 items-end mb-10">
                        <div className="space-y-3 text-left flex-1 min-w-[200px] max-w-sm ml-2">
                            <label className="text-[14px] font-black text-gray-400 tracking-tight ml-1">वर्ष निवडा</label>
                            <div className="flex gap-4">
                                <select 
                                    className="flex-grow border border-gray-200 rounded-lg px-5 py-2.5 outline-none focus:border-[#6366f1] bg-white text-gray-700 font-bold transition-all appearance-none text-sm"
                                    value={year}
                                    onChange={(e) => setYear(e.target.value)}
                                >
                                    <option value="वर्ष निवडा">वर्ष निवडा</option>
                                    <option value="२०२६">२०२६</option>
                                    <option value="२०२५">२०२५</option>
                                    <option value="२०२४">२०२४</option>
                                </select>
                                <button className="bg-[#6366f1] hover:bg-[#4f46e5] text-white px-8 py-2.5 rounded-lg font-bold shadow-lg shadow-indigo-500/10 transition transform active:scale-95 flex items-center gap-2 uppercase tracking-wide text-sm">
                                    शोध
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Table Section */}
                    <div className="overflow-x-auto border border-gray-100 rounded-xl shadow-sm">
                        <table className="w-full border-collapse">
                            <thead>
                                <tr className="bg-white border-b border-gray-100 text-[12px] font-black text-gray-800 text-left">
                                    <th className="px-5 py-5 border-r border-gray-50 min-w-[50px]">#</th>
                                    <th className="px-5 py-5 border-r border-gray-50 min-w-[220px]">अर्जदाराचे नाव</th>
                                    <th className="px-5 py-5 border-r border-gray-50 min-w-[150px]">फोन नंबर.</th>
                                    <th className="px-5 py-5 border-r border-gray-50 min-w-[120px]">तालुका</th>
                                    <th className="px-5 py-5 border-r border-gray-50 min-w-[150px]">कामांची संख्या</th>
                                    <th className="px-5 py-5 border-r border-gray-50 min-w-[150px]">कामाची रक्कम</th>
                                    <th className="px-5 py-5 border-r border-gray-50 min-w-[150px]">परवाना तारीख</th>
                                    <th className="px-5 py-5 min-w-[120px]">तारीख जोडा</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, index) => (
                                    <tr key={index} className="hover:bg-blue-50/10 transition-colors border-b border-gray-50 last:border-0 text-[13px] text-gray-700 font-bold text-left">
                                        <td className="px-5 py-5 border-r border-gray-50">{item.id}</td>
                                        <td className="px-5 py-5 border-r border-gray-50 tracking-tight">{item.name}</td>
                                        <td className="px-5 py-5 border-r border-gray-50 text-gray-600 font-hind">{item.phone}</td>
                                        <td className="px-5 py-5 border-r border-gray-50">{item.taluka}</td>
                                        <td className="px-5 py-5 border-r border-gray-50">
                                            <div className="flex items-center gap-2">
                                                {item.count} - <button className="text-[#3b82f6] hover:text-[#2563eb] hover:underline transition-colors font-bold">कामाचे तपशील</button>
                                            </div>
                                        </td>
                                        <td className="px-5 py-5 border-r border-gray-50 font-hind">{item.amount || "-"}</td>
                                        <td className="px-5 py-5 border-r border-gray-50">{item.licenseDate}</td>
                                        <td className="px-5 py-5 font-hind">{item.joinDate}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Search Suggestion (Matches bottom of image) */}
                <div className="mt-6 flex justify-end items-center gap-3">
                    <span className="text-[12px] font-bold text-gray-400 uppercase tracking-widest">Showing 8 Results</span>
                </div>
            </div>

            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Hind:wght@400;500;600;700&display=swap');
                .font-hind {
                    font-family: 'Hind', sans-serif;
                }
            `}</style>
        </EngineerLayout>
    );
};

export default EngineerLotterySubWorksDistributionList;
